;(function() {
  'use strict'

  Controller.$inject = ["$state", "userService", "cloudinaryService", "clipboardService"];
  angular.module('app.core').component('projectTrackerCard', {
    controller: Controller,
    templateUrl: 'project-tracker-card.html',
    bindings: {
      tracker: '<',
      layout: '@',
      onEdit: '&?',
    },
  })

  /* @ngInject */
  function Controller(
    $state,
    userService,
    cloudinaryService,
    clipboardService
  ) {
    var ctrl = this

    ctrl.$onInit = onInit
    ctrl.$onChanges = onChanges
    ctrl.getMenuItems = getMenuItems

    function onInit() {
      ctrl.isSSR = userService.isSSR()
    }

    function onChanges() {
      ctrl.isRow = ctrl.layout === 'row'
      ctrl.href = getHref()

      var imageUrl = cloudinaryService.resize(
        ctrl.tracker.imageUrl,
        ctrl.isRow ? 160 : 400
      )
      ctrl.imageStyle = imageUrl && {
        backgroundImage: 'url(' + imageUrl + ')',
      }
    }

    function getHref(options) {
      return $state.href(
        'projectTracker',
        { id: ctrl.tracker.projectId, trackerId: ctrl.tracker.id },
        options
      )
    }

    function getMenuItems() {
      return [
        { text: 'Copy link', onClick: copyLink },
        ctrl.isSSR && ctrl.onEdit && { text: 'Edit', onClick: ctrl.onEdit },
      ]
    }

    function copyLink() {
      clipboardService.copy(getHref({ absolute: true }))
    }
  }
})()
